export default {
  questionMustBeUniq: 'Question must be unique',
  kitIsAlreadyExist: 'Kit with given kit_id already exists.',
  multipleBookingNotAllowed: 'Participant not allow to join multiple sessions.',
};
